// redux/services/bannerService/banner.Services.js
import { baseApi } from "../baseApi";

export const bannerApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    // Get all banners
    getBanners: builder.query({
      query: (params = {}) => {
        const { page = 1, limit = 10, search = "", status = "" } = params;
        let queryString = `/banner-list?page=${page}&limit=${limit}`;
        if (search) queryString += `&search=${search}`;
        if (status) queryString += `&status=${status}`;
        console.log('API Call URL:', queryString); // Debug
        return queryString;
      },
      providesTags: ["Banner"],
      keepUnusedDataFor: 60,
      // ✅ Add this to prevent unnecessary re-fetches
      refetchOnMountOrArgChange: false,
      refetchOnReconnect: false,
      refetchOnFocus: false,
      transformResponse: (response) => {
        console.log('API Response:', response); // Debug
        return {
          data: response.data || [],
          pagination: response.pagination || {
            total: 0,
            page: 1,
            limit: 10,
            totalPages: 0,
          },
          imageBaseUrl: response.imageBaseUrl || "",
          success: response.success,
          message: response.message,
        };
      },
    }),

    // Get single banner
    getBannerDetail: builder.query({
      query: (id) => `/banner-detail/${id}`,
      providesTags: (result, error, id) => [{ type: "Banner", id }],
      keepUnusedDataFor: 60,
    }),

    // Create banner
    createBanner: builder.mutation({
      query: (formData) => ({
        url: "/banner-create",
        method: "POST",
        body: formData,
      }),
      invalidatesTags: ["Banner"],
    }),

    // Update banner
    updateBanner: builder.mutation({
      query: ({ id, formData }) => ({
        url: `/banner-edit/${id}`,
        method: "POST",
        body: formData,
      }),
      invalidatesTags: (result, error, { id }) => [
        { type: "Banner", id },
        "Banner",
      ],
    }),

    // Toggle banner status
    changeBannerStatus: builder.mutation({
      query: (id) => ({
        url: `/banner-status/${id}`,
        method: "GET",
      }),
      invalidatesTags: (result, error, id) => [
        { type: "Banner", id },
        "Banner",
      ],
    }),

    // Delete banner
    deleteBanner: builder.mutation({
      query: (id) => ({
        url: `/banner-delete/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: (result, error, id) => [
        { type: "Banner", id },
        "Banner",
      ],
    }),
  }),
});

export const {
  useGetBannersQuery,
  useGetBannerDetailQuery,
  useCreateBannerMutation,
  useUpdateBannerMutation,
  useChangeBannerStatusMutation,
  useDeleteBannerMutation,
  useLazyGetBannersQuery,
} = bannerApi;